<mat-dialog-header>
    <button mat-button style="display: block;float: right;position: relative;top: -20px;right: -24px; margin-bottom: -10px;" [mat-dialog-close]="false"><mat-icon>close</mat-icon></button>
    <div class="clearfix"></div>
    <h1 style="text-align: center; color: #003982; margin-top: 0px;margin-bottom: 0px;">Gracias. Tus datos han sido confirmados</h1>
</mat-dialog-header>
<mat-dialog-content>
    <p style="text-align: center;">
        Los puedes cambiar cuando quieras <br/>accediendo a esta URL con el link en el <br/>mensaje que te enviamos
    </p>
</mat-dialog-content>